import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteApiData } from "../helpers/AxiosInstance";

interface Props {
  queryKey: string[];
  navigateURL?: string | null;
}

const useDeleteHook = ({ queryKey, navigateURL = null }: Props) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {
    isPending: isLoading,
    mutateAsync,
    isSuccess,
    data,
    isError,
  } = useMutation({
    mutationFn: deleteApiData,
    onSuccess: () => {
      toast.success("Deleted successfully");
      if (navigateURL) {
        navigate(navigateURL);
      }
    },
    onError: (error) => {
      throw error;
    },
    onSettled: () => {
      queryClient.refetchQueries();
    },
  });

  return {
    isLoading,
    mutateAsync,
    isSuccess,
    data,
    isError,
  };
};

export default useDeleteHook;
